import { useState, useCallback } from 'react';

export const useConfirm = () => {
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'warning',
    confirmText: 'Confirmer',
    cancelText: 'Annuler',
    onConfirm: null,
    isLoading: false
  });

  const confirm = useCallback(({
    title = 'Confirmation',
    message = 'Êtes-vous sûr de vouloir continuer ?',
    type = 'warning',
    confirmText = 'Confirmer',
    cancelText = 'Annuler'
  } = {}) => {
    return new Promise((resolve) => {
      setConfirmState({
        isOpen: true,
        title,
        message,
        type,
        confirmText,
        cancelText,
        onConfirm: resolve,
        isLoading: false
      });
    });
  }, []);

  const handleConfirm = useCallback(async () => {
    if (confirmState.onConfirm) {
      setConfirmState(prev => ({ ...prev, isLoading: true }));
      
      try {
        // Attendre un court délai pour l'animation
        await new Promise(resolve => setTimeout(resolve, 150));
        confirmState.onConfirm(true);
      } finally {
        setConfirmState(prev => ({ 
          ...prev, 
          isOpen: false, 
          isLoading: false,
          onConfirm: null 
        }));
      }
    }
  }, [confirmState]);

  const handleCancel = useCallback(() => {
    if (confirmState.onConfirm) {
      confirmState.onConfirm(false);
    }
    setConfirmState(prev => ({ 
      ...prev, 
      isOpen: false, 
      onConfirm: null,
      isLoading: false 
    }));
  }, [confirmState]);

  return {
    confirm,
    confirmProps: {
      isOpen: confirmState.isOpen,
      title: confirmState.title,
      message: confirmState.message,
      type: confirmState.type,
      confirmText: confirmState.confirmText,
      cancelText: confirmState.cancelText,
      isLoading: confirmState.isLoading,
      onConfirm: handleConfirm,
      onClose: handleCancel
    }
  };
};

export default useConfirm;
